import { prop} from "fw";

export class Divider {
  @prop(null) color?: string
}
